module.exports = __webpack_public_path__ + "img/the-joi-database-logo.f1145671.png";